import * as React from "react"

// sm:px-10 md:px-10 lg:px-10 xl:px-30
// sm:px-10 md:px-20 lg:px-20 xl:px-20

// sm:px-20 md:px-30 lg:px-30 xl:px-50

const Container = ({ className, innerClassName, children, ...props }) => (
	<div className={`xl:container px-10 xl:px-30 ${className || ""}`} {...props}>
		<div className={`px-10 md:px-20 ${innerClassName || ""}`}>{children || ""}</div>
	</div>
)

export default Container
